import React, { useEffect, useRef, useState, useCallback } from "react"
import "./ThemeSong.scss"
import { Player } from "@lottiefiles/react-lottie-player"
import DecoLine01 from "@lotties/deco-line01.json"
import DecoLine02 from "@lotties/deco-line02.json"
import Division from "@lotties/division.json"
import DivisionShort from "@lotties/division-short.json"

const useLottieAnimation = delay => {
  const playerRef = useRef(null)

  useEffect(() => {
    const timeout = setTimeout(() => {
      playerRef.current?.play()
    }, delay)

    return () => clearTimeout(timeout)
  }, [delay])

  return playerRef
}

const useRotationAnimation = (initialSpeed, reverse = false) => {
  const [rotation, setRotation] = useState(0)
  const [speed, setSpeed] = useState(initialSpeed)
  const requestRef = useRef()
  const lastTimestampRef = useRef(performance.now())

  const animate = useCallback(
    timestamp => {
      const deltaTime = timestamp - lastTimestampRef.current
      lastTimestampRef.current = timestamp

      setRotation(prev => prev + (reverse ? 1 : -1) * (360 / speed) * deltaTime)
      requestRef.current = requestAnimationFrame(animate)
    },
    [speed, reverse]
  )

  useEffect(() => {
    requestRef.current = requestAnimationFrame(animate)
    return () => cancelAnimationFrame(requestRef.current)
  }, [animate])

  return { rotation, setSpeed }
}

const ThemeSong = ({ openYoutubeModal }) => {
  const playerRef1 = useLottieAnimation(2000)
  const playerRef2 = useLottieAnimation(2000)

  const { rotation, setSpeed: setLargeArcSpeed } = useRotationAnimation(2000)
  const { rotation: smallArcRotation, setSpeed: setSmallArcSpeed } =
    useRotationAnimation(3000, true)

  const handleMouseEnter = () => {
    setLargeArcSpeed(8000)
    setSmallArcSpeed(12000)
  }

  const handleMouseLeave = () => {
    setLargeArcSpeed(2000)
    setSmallArcSpeed(3000)
  }

  const handleKeyDown = e => {
    if (e.key === "Enter" || e.key === " ") {
      openYoutubeModal("hArVcjfG9vI")
    }
  }

  return (
    <>
      <section className="theme-song" id="theme-song">
        <div className="theme-song-inner">
          <h2 className="section-title theme-song-title">Theme Song</h2>
          <div
            className="theme-song-movie"
            onClick={() => openYoutubeModal("hArVcjfG9vI")}
            tabIndex={0}
            role="button"
            aria-label="Play YouTube video"
            onKeyDown={handleKeyDown}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            data-gtm-click="themeSong-youtubeMovie"
          >
            <div className="theme-song-movie-cover"></div>
            <div
              className="large-arc"
              style={{
                transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
              }}
            ></div>
            <div
              className="small-arc"
              style={{
                transform: `translate(-50%, -50%) rotate(${smallArcRotation}deg)`,
              }}
            ></div>
            <iframe
              className="theme-song-movie-player"
              width="560"
              height="315"
              tabIndex={-1}
              src="https://www.youtube.com/embed/hArVcjfG9vI?si=NP_cuZvzW6BKj4Wx?controls=0&amp;autoplay=1&amp;mute=1&amp;loop=1&amp;playlist=hArVcjfG9vI&amp;disablekb=1&amp;enablejsapi=1&amp;iv_load_policy=3&amp;playsinline=1&amp;rel=0&amp;origin=http%3A%2F%2Flocalhost%3A8000&amp;widgetid=1"
              title="V4 Mirai Pv"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
          <div className="song-theme-info"></div>
          <div className="theme-song-ornament">
            <Player
              className="deco-line4-sp deco-line4-top"
              ref={playerRef2}
              loop
              src={DivisionShort}
            />
            <Player
              className="deco-line4-sp deco-line4-bottom"
              autoplay
              loop
              src={DivisionShort}
            />
            <Player
              className="deco-line4 deco-line4-top"
              ref={playerRef1}
              loop
              src={Division}
            />
            <Player
              className="deco-line4 deco-line4-bottom"
              autoplay
              loop
              src={Division}
            />
            <Player className="deco-line2" autoplay loop src={DecoLine02} />
            <Player className="deco-line1" autoplay loop src={DecoLine01} />
          </div>
        </div>
      </section>
    </>
  )
}

export default ThemeSong
